import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Table, TableModule } from "primeng/table";
import { QuoteNotesGridService } from "../../../../core/services/quote-notes-grid.service";
import { SalesOrderNotes } from "../../../../core/models/orders/salesOrderNotes";
import { QuotesNotesDto } from "../../../../core/models/qoutes/quotesNotesDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { OrderNotesSidebarService } from "../../../../core/services/order-notes-sidebar.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { CommonModule } from "@angular/common";
import { SelectModule } from "primeng/select";
import { FormsModule } from "@angular/forms";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@UntilDestroy()
@Component({
  selector: "jni-quote-notes-grid",
  templateUrl: "./quote-notes-grid.component.html",
  styleUrls: ["./quote-notes-grid.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    SelectModule,
    FormsModule,
    HidedynamicsdatePipe,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class QuoteNotesGridComponent implements OnInit {
  @Input() quoteId = "";
  @Input() orderNotesGridListing: QuotesNotesDto[] = [];
  @Input() fromSummary = false;
  @Output() selectedOrderNotesListing = new EventEmitter<SalesOrderNotes[]>();
  @Output() closeModalEvent = new EventEmitter();

  @ViewChild("dt") table!: Table;
  onPurchaseorderstatus = false;
  purchaseOrderNumber: string[] = [];
  selectedOrderNotesGridListing: SalesOrderNotes[] = [];

  typeList = [
    {
      id: 1,
      name: "Proposal",
    },
    {
      id: 2,
      name: "Billing note",
    },
    {
      id: 3,
      name: "Order note",
    },
  ];

  constructor(
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private _quoteNotesGridService: QuoteNotesGridService,
    private _orderNotesSidebarService: OrderNotesSidebarService
  ) {}

  ngOnInit(): void {
    if (this.quoteId) {
      this.getQuoteNotes(this.quoteId);
      this.getAllLinePoNumber(this.quoteId);
    }
  }

  getQuoteNotes(quoteId: string) {
    this._quoteNotesGridService
      .getQuoteNotes(quoteId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.selectedOrderNotesGridListing = [];
          if (res.data) {
            this.orderNotesGridListing = res.data;
          }
        },
        error: res => {
          this._toastr.error("Error", res.message || "Order note not found");
        },
      });
  }

  getAllLinePoNumber(quoteId: string) {
    if (quoteId) {
      this._orderNotesSidebarService
        .getAllLinePoNumber(quoteId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.purchaseOrderNumber = res.data;
          },
        });
    }
  }

  onEditRow(orderNotesGridListing: SalesOrderNotes) {
    this.cancelAllEditRow();
    const row = this.table.value.filter(x => x.id === orderNotesGridListing.id);
    if (row.length > 0) {
      this.table.initRowEdit(row[0]);
    }
  }

  cancelAllEditRow() {
    this.table.value.forEach(x => {
      this.table.cancelRowEdit(x);
    });
  }

  onRowEditSave(orderNotesGridListing: SalesOrderNotes) {
    this.cancelAllEditRow();
    if (!orderNotesGridListing.type) {
      this._toastr.error("Error", "Type is required");
      this.getQuoteNotes(this.quoteId);
      return;
    }
    if (!orderNotesGridListing.description) {
      this._toastr.error("Error", "Description is required");
      this.getQuoteNotes(this.quoteId);
      return;
    }

    this._loaderService.setLoaderState(true);
    this._quoteNotesGridService
      .AddQuoteNotes(orderNotesGridListing)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.getQuoteNotes(this.quoteId);
            this._toastr.success(
              "Success",
              res.message || "Proposal note update successfully"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error updating order note"
          );
        },
      });
  }

  updateSingleLine() {
    if (this.selectedOrderNotesGridListing.length === 1) {
      this.selectedOrderNotesListing.emit(this.selectedOrderNotesGridListing);
    }
  }

  deleteSaleOrderNotes() {
    const array: number[] = [];
    if (this.selectedOrderNotesGridListing.length > 0) {
      this.selectedOrderNotesGridListing.forEach(x => {
        array.push(x.id);
      });
      this._loaderService.setLoaderState(true);
      this._quoteNotesGridService
        .deleteQuotesNotes(array)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this.getQuoteNotes(this.quoteId);
              this.selectedOrderNotesGridListing = [];
              this._toastr.success(
                "Success",
                res.message || "Proposal note delete successfully"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error deleting order note"
            );
          },
        });
    }
  }

  disabledField(type: string) {
    if (type === "Billing note") {
      return false;
    } else if (type === "Order note") {
      return false;
    } else {
      return true;
    }
  }

  onPurchaseorderchange(type: string, id: number) {
    if (type === "Billing note") {
      this.onPurchaseorderstatus = false;
    } else if (type === "Order note") {
      this.onPurchaseorderstatus = false;
    } else {
      this.onPurchaseorderstatus = true;
      const lineObject = this.orderNotesGridListing?.find(x => x?.id === id);
      if (lineObject) {
        if (lineObject?.purchaseOrderId) {
          lineObject.purchaseOrderId = "";
        }
      }
    }
  }

  redirectToAttachment(attachmentURL: string) {
    if (attachmentURL) {
      window.open(attachmentURL, "_blank");
    }
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  onCloseModal() {
    this.closeModalEvent.emit();
  }
}
